export default __webpack_public_path__ + "static/media/rnr-sports-table-14.a243b9c6.webp";